const errorContent = {
  connect: {
    title: "Connection Failed",
    message:
      "We were unable to connect your HubSpot and BoldSign accounts. Please try again or contact support if the issue persists. You can close this window now.",
  },
  disconnect: {
    title: "Disconnection Failed",
    message:
      "We were unable to disconnect your HubSpot and BoldSign accounts. Please try again or contact support if the issue persists. You can close this window now.",
  },
  sendRequest: {
    title: "Send Request Failed",
    message:
      "We were unable to send your signature request. Please try again or contact support if the issue persists. You can close this window now.",
  },
  loadTemplates: {
    title: "Failed to load templates",
    message:
      "We were unable to load your templates. Please try again or contact support if the issue persists. You can close this window now.",
  },
  createTemplate: {
    title: "Template Creation Failed",
    message:
      "We were unable to create your template. Please try again or contact support if the issue persists. You can close this window now.",
  },
  default: {
    title: "Operation Failed",
    message:
      "We were unable to complete this action. Please try again or contact support if the issue persists. You can close this window now.",
  },
};

export default errorContent;
